<script>
export default {
    functional: true,
    render: (h, ctx) => ctx.props.vnode,
}
</script>
